import { Component } from '@angular/core';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CMSService } from '../Services/cms.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cms-sub-landing',
  templateUrl: './cms-sub-landing.component.html',
  styleUrls: ['./cms-sub-landing.component.css']
})
export class CmsSubLandingComponent {
  cmsLandingObj = new CmsLoginMainContentProperties();
  constructor(private router: Router,private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }
  public progress: number;
  public imagePath: string;
  public message: string;
  baseUrl = environment.baseUrl;
  public responseMessage: string;
  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.http.post(this.baseUrl+'/CmsLogin/SaveLandingBG', formData, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.imagePath = event.body.toString();
          this.message = 'Uploaded Successfully...';
        }
      });
  }
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {
        let sr = Number(localStorage.getItem("serialNo"));
        if (sr != 0) {
          this.userService.getMainContentById(sr).subscribe((data) => {
            this.cmsLandingObj = data[0] as CmsLoginMainContentProperties;
            localStorage.removeItem("serialNo");
          });
        }
      }
    }
    catch (e) {
      //////////console.log (e);
    }
  }

  onSubmit() {
    this.imagePath = " ";
    if (this.cmsLandingObj.sr == 0) {
      this.cmsLandingObj.image = this.imagePath;
      this.userService.createMainContent(this.cmsLandingObj).subscribe((data => {
        if (data === true) {
          this.router.navigate(["/cms"]);
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
    else {
      this.cmsLandingObj.image = this.imagePath;
      this.userService.updateMainContent(this.cmsLandingObj).subscribe((data => {
        if (data === true) {
          this.router.navigate(["/cms"]);
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
    
  }
  cancel() {
    this.router.navigate(["/cms"]);
  }
}
